import { useState, useEffect } from 'react';

// supports messageStyle error, success, warning, notice
export const Message = ({
  fadeoutMessage = true, 
  isFormMessage = true,
  messageStyle = 'success',
  title,
  message,
  children,
  rerenderCounter,
  closable = false, // if true, the message will be closable with X icon.
}) => {
  const [showMessage, setShowMessage] = useState(true);
  const [fadeout, setFadeout] = useState(false);

  useEffect(() => {
    // start fadeout after 2 seconds, remove element after 3 seconds
    if (fadeoutMessage && !closable) {
      setShowMessage(true);
      setFadeout(false);
      setTimeout(function () {
        setShowMessage(false);
      }, 6500);
      setTimeout(function () {
        setFadeout(true);
      }, 4500);
    }
  }, [rerenderCounter]);

  const handleClose = () => {
    setFadeout(true);
    setTimeout(() => {
      setShowMessage(false);
    }, 200);
  };

  if (!showMessage) {
    // empty response
    return <></>;
  }

  return (
    <div
      className={
        `sb-message sb-flex sb-message-${messageStyle}` +
        (fadeout ? ' sb-message-fadeout' : '') +
        (isFormMessage ? ' sb-message-form-message' : '') +
        (closable ? ' sb-message-closable' : '')
      }
    >
      <span className="sb-message-icon" />
      <div className="sb-message-content">
        {title && <p className="sb-message-title">{title}</p>}
        {message && <p className="sb-message-msg">{message}</p>}
        {children && <p className="sb-message-msg">{children}</p>}
      </div>
      {closable && (
        <button
          type="button"
          className="sb-message-close"
          onClick={handleClose}
          aria-label="Close message"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      )}
    </div>
  );
};
